export default {
      id: "hat-star-usage",
      viewBox: "0 0 640 486",
      url: "../../assets/" + "sprite.svg#hat-star-usage",
      toString: function () {
        return this.url;
      }
    }